import { Switch } from "react-router";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AppRoute from "@/common/components/Routing/AppRoute";
import { ROUTE_PATH } from "@/common/constants/routing";
import { EnvHelper } from "@/common/helpers/env";

import NotFoundErrorPage from "../BaseApp/Error/NotFoundErrorPage";
import { DevDashboard } from "../DevArea/DevDashboard";
import { DevStyleguide } from "../DevArea/DevStyleguide/DevStyleguide";
import BaseAppLayout from "../Layouts/BaseAppLayout";

export function DevAreaContent() {
  if (!EnvHelper.isDevelopmentAny) {
    return null;
  }

  return (
    <BaseAppLayout>
      {/* NB: don't use React.Fragment in Switch as it breaks routes. */}
      <Switch>
        <AppRoute
          exact
          path={RoutePathBuilder.toDefinition(ROUTE_PATH.DEV_DASHBOARD)}
          render={() => <DevDashboard />}
        />
        <AppRoute
          exact
          path={RoutePathBuilder.toDefinition(ROUTE_PATH.DEV_STYLEGUIDE)}
          render={() => <DevStyleguide />}
        />
        <AppRoute
          path={`${RoutePathBuilder.toDefinition(ROUTE_PATH.DEV_STYLEGUIDE)}/*`}
          render={() => <DevStyleguide />}
        />

        <AppRoute
          exact
          path={ROUTE_PATH.APP_AREA_DEV}
          render={() => (
            // <RootRouteEntry />
            <DevDashboard />
          )}
        />

        <AppRoute render={() => <NotFoundErrorPage />} />
      </Switch>
    </BaseAppLayout>
  );
}
